export default "__VITE_ASSET__CtKRv7$N__"